import React from "react";

interface Props {
	children: React.ReactElement | React.ReactElement[];
	marginBottom?: string;
}

const FormControl: React.FC<Props> = ({children, marginBottom}) => {

	return (
		<div className="form-group" style={{marginBottom: marginBottom}}>
			{children}
		</div>
	)
}

export default FormControl;